import React, { Fragment, useEffect, useState } from 'react'
import Navbar from './components/ui/Navbar'
import "./App.css"
import axios from 'axios'
import User from './components/users/User'
import Spinner from './components/ui/Spinner'
import FindUser from './components/users/FindUser'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import About from './components/pages/About'
import SearchedUser from './components/users/SearchedUser'
import { FaGithub } from 'react-icons/fa'

let githubClientId;
let githubClientSecret;

if (process.env.NODE_ENV !== "production") {
  githubClientId = process.env.REACT_APP_GITHUB_CLIENT_ID;
  githubClientSecret = process.env.REACT_APP_GITHUB_CLIENT_SECRET;
} else {
  githubClientId = process.env.GITHUB_CLIENT_ID;
  githubClientSecret = process.env.GITHUB_CLIENT_SECRET;

}

const App = () => {
  const [welcome, setWelcome] = useState(false)
  const [error, setError] = useState(false)
  const [user, setUser] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setWelcome(true)
  }, [])

  const findUserHandler = (name, setName) => {
    setError(false)
    setWelcome(false)
    setUser([])
    setLoading(true)
    axios.get(`https://api.github.com/search/users?q=${name}&client_id=${githubClientId}&client_secret=${githubClientSecret}`)
      .then(res => {
        setLoading(false)
        setUser(res.data.items)
        setTimeout(() => {
          setError(true)
        }, 200)
      })
    setName("")
  }

  const clearHandler = () => {
    setUser([])
  }

  return (
    <Router>
      <div className="App">
        <Navbar />
        <div className="container">
          <Switch>
            <Route exact path="/" render={(props) => (
              <Fragment>
                <FindUser findUserHandler={findUserHandler} welcome={welcome} />
                {
                  loading && <Spinner />
                }
                <User users={user} error={error} />
              </Fragment>
            )} />
            <Route exact path="/about" component={About} />
            <Route exact path="/users/:login" render={props => (
              <SearchedUser {...props}
                loading={loading} setLoading={setLoading} githubClientId={githubClientId} githubClientSecret={githubClientSecret} />
            )} />
          </Switch>
        </div>
      </div>
    </Router>
  )
}

export default App


